import { IonAlert } from '@ionic/react'
import { Button } from '@mui/material'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { logEvent } from '../../../../analytics/utils/firebaseUtils'
import useUser from '../../../../contexts/hooks/useUser'
import { UserContext } from '../../../../contexts/UserContext'
import { trpc } from '../../../../modules/trpc'
import PageWrapper from '../../../../wrappers/pageWrapper/PageWrapper'

const DeleteAccountConfirmation: React.FC = () => {
	const { user } = useUser()

	const history = useHistory()

	const [showAlert, setShowAlert] = useState(false)
	const { logOut } = useContext(UserContext)

	const { t } = useTranslation('pages_settings', {
		keyPrefix: 'accountManagement.dataRemoval.deleteAccountModal',
	})
	const { t: tc } = useTranslation('common')

	const { mutate: deleteUser } = trpc.user.delete.useMutation({
		onSuccess: () => {
			logEvent('delete-account-success')
			logOut()
		},
		onError: error => {
			logEvent('delete-account-error', { error: error.message })
			console.error('Error deleting user data:', error)
		},
	})

	const handleDeleteConfirm = () => {
		logEvent('click-user-delete-all-data')
		if (user?.id) {
			deleteUser()
		}
	}

	return (
		<PageWrapper page='deleteAccount-confirmation' appBarOptions={{ backPath: '/settings' }}>
			<div className='confirmation'>
				<div className='warning-text text-text-dark dark:text-white'>{t('warning1')}</div>
				<div className='description text-text-dark dark:text-white'>{t('warning2')}</div>
				<Button
					className='![--background:theme(colors.highlight)] dark:![--background:theme(colors.highlight)] font-semibold tracking-wide'
					onClick={() => setShowAlert(true)}
				>
					{t('delete')}
				</Button>
				<Button className='font-semibold tracking-wide' onClick={() => history.goBack()}>
					{tc('peruuta')}
				</Button>

				<div className='description-bottom text-text-dark dark:text-white'>{t('warning3')}</div>
			</div>

			<IonAlert
				isOpen={showAlert}
				onDidDismiss={() => setShowAlert(false)}
				header={t('areYouSure')}
				message={t('disclaimer')}
				className='
                    dark:[--background:#063a3e] [--background:#f5f5f5]
                    [&_.alert-button-delete]:!text-highlight
                    [&_.alert-button-delete]:!font-semibold
                    [&_.alert-button-delete]:!tracking-wider
                    [&_.alert-button-cancel]:!text-brand-primary-100-light
                    [&_.alert-button-cancel]:!font-semibold
                    [&_.alert-button-cancel]:!tracking-wider
                    dark:[&_.alert-button-cancel]:!text-brand-primary-100-dark
                    [&_.alert-message]:!text-text-grey-200
                    dark:[&_.alert-title]:!text-white
                    [&_.alert-title]:!text-text-dark
                    dark:[&_.alert-message]:!text-text-grey-100
                '
				buttons={[
					{
						text: tc('poista'),
						role: 'destructive',
						handler: () => {
							handleDeleteConfirm()
						},
						cssClass: 'alert-button-delete',
					},
					{
						text: tc('peruuta'),
						role: 'cancel',
						cssClass: 'alert-button-cancel',
					},
				]}
			/>
		</PageWrapper>
	)
}

export default DeleteAccountConfirmation
